import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=bcc7d12c"
import script from "./TableSettings.vue?vue&type=script&lang=js"
export * from "./TableSettings.vue?vue&type=script&lang=js"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=bcc7d12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports